import { render } from "./LayoutSite.vue?vue&type=template&id=51daa11a&lang=pug"
import script from "./LayoutSite.vue?vue&type=script&lang=js"
export * from "./LayoutSite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__